import { createSelector } from '@reduxjs/toolkit';
import { getLmsSessionIdentityKey } from 'src/models/auth/lmsLogin/selector';
import { getPerformanceCards } from 'src/models/lmsConfig/selectors';
import { getMenuV2, isPerformanceDashboardEnabled } from './queries';

export const getMenuItems = createSelector(
  [getLmsSessionIdentityKey, getPerformanceCards],
  (_lmsSessionIdentityKey, performanceCards) => {
    const menuItems = getMenuV2();

    if (isPerformanceDashboardEnabled()) {
      const performanceItems: any = [
        {
          name: 'Dashboard',
          code: 'performance-dashboard',
          key: 'performance-dashboard',
          icon: '',
          display: true,
          type: 'performance',
          path: '/performance/home',
        },
      ];

      if (performanceCards.find((card) => card.code === 'leaderboard')) {
        performanceItems.push({
          name: 'Leaderboard',
          code: 'performance-leaderboard',
          key: 'performance-leaderboard',
          type: 'performance',
          path: '/performance/leaderboard',
        });
      }

      if (performanceCards.find((card) => card.code === 'key_metrics')) {
        performanceItems.push({
          name: 'Key Metrics',
          code: 'performance-key-metrics',
          key: 'performance-key-metrics',
          type: 'performance',
          path: '/performance/key_metrics',
        });
      }

      menuItems.push({
        name: 'Performance',
        key: 'performance',
        code: 'performance',
        type: 'performance',
        items: performanceItems,
      });
    }

    return menuItems;
  },
);
